export const FINANCE_ACTION = 'FINANCE_ACTION';
export const ACT_ACTION = 'ACT_ACTION';
export const CHANGE_ACT_EMAIL = 'CHANGE_ACT_EMAIL';
export const SEND_ACT_EMAIL = 'SEND_ACT_EMAIL';



/** WEBPACK FOOTER **
 ** ./src/modules/finance/actions/types.js
 **/